// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MJ-z","isFullWidth":"NJ-z","landingPageVideo":"OJ-z","play":"PJ-z","iframeVideo":"QJ-z","playHidden":"RJ-z","fullwidth":"SJ-z"};